module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"create new customer":"Create new customer settings","create":"Create","cancel":"Cancel"},"de":{"create new customer":"Neuen Kunden anlegen","create":"Anlegen","cancel":"Abbrechen"}}')
  delete Component.options._Ctor
}
